import React from "react";
import { Spinner } from "react-bootstrap";
import loadingcss from "../../../sass/enquiry-list/Enquiry.module.scss";

export const LoadingOverlay = () => {
  return (
    // <div className="position-relative">
    <div
      className={loadingcss.overlayLoadingContainer}
      style={{
        transform: "translate(-50%, -50%)",
      }}
    >
      <Spinner
        animation="border"
        style={{
          fontSize: "15px",
          height: "20px",
          width: "20px",
        }}
      />
    </div>
    // </div>
  );
};
